<template>
  <div>TEST RUN LISTENER</div>
</template>

<script>
import {onMounted, onBeforeUnmount} from 'vue'
import {Echo} from '../../common/socket'

export default {
  name: 'test-run',
  props: {
    trid: {
      type: [String, Number],
      required: true
    }
  },
  setup(props) {
    let channel = null;
    onMounted(() => {

      const channelPrefix = document.head.querySelector('meta[name="broadcast-channel-prefix"]').content;
      const channelName = `${channelPrefix}.testrun.${props.trid}`
      console.log(channelName)
      if (Echo && props.trid) {
        channel = Echo.channel(channelName)
            .listen('TestRunUpdated', (e) => {
              console.log('TestRunUpdated event received:', e);
            });
      } else {
        console.warn('Echo is not defined or testRunId missing.');
      }
    });
    onBeforeUnmount(() => {
      if (channel) {
        channel.stopListening('TestRunUpdated');
      }
    });
    return {};
  }
};
</script> 